import { useEffect } from 'react';
import { useQueryParam, StringParam } from 'use-query-params';
import { useMediaQueryContext, useModalContext } from '@fourthwall/components';
import { AddProductToFavoritesModal } from '@fourthwall/module-product';
import { useCatalogProductQuery } from './queries/useCatalogProductQuery';
import { useAddProductToFavoritesMutation } from './queries/useAddProductToFavoritesMutation/useAddProductToFavoritesMutation';
import { useDeleteProductFromFavoritesMutation } from './queries/useDeleteProductFromFavoritesMutation/useDeleteProductFromFavoritesMutation';
export const useAddProductToFavoritesModal = () => {
    const [fromProductParam, setFromProductParam] = useQueryParam('fromProduct', StringParam);
    const { tablet } = useMediaQueryContext();
    const { open, close } = useModalContext();
    const { addProductToFavoritesMutation } = useAddProductToFavoritesMutation();
    const { deleteProductFromFavoritesMutation } = useDeleteProductFromFavoritesMutation();
    const { catalogProductQuery } = useCatalogProductQuery([fromProductParam], {
        enabled: Boolean(fromProductParam),
    });
    useEffect(() => {
        if (fromProductParam && !tablet && catalogProductQuery.data) {
            const product = catalogProductQuery.data;
            open(AddProductToFavoritesModal, {
                product,
                isFavorite: product.favourite,
                disabled: catalogProductQuery.isFetching,
                onAdd: async () => {
                    await addProductToFavoritesMutation.mutateAsync([product.slug]);
                },
                onRemove: async () => {
                    await deleteProductFromFavoritesMutation.mutateAsync([product.slug]);
                },
                onClose: close,
            });
        }
        setFromProductParam(undefined);
    }, [
        tablet,
        fromProductParam,
        open,
        setFromProductParam,
        catalogProductQuery,
        close,
        addProductToFavoritesMutation,
        deleteProductFromFavoritesMutation,
    ]);
};
